module.exports = __webpack_public_path__ + "static/digital-walkaround-checks-20d5a64808f6be90344b5ff309f0a3fe.jpg";